import SelectEventsModal from './SelectEventsModal';

export default SelectEventsModal;
